var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHappyicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69,
    height: 70,
    viewBox: "0 0 69 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_542",
    "data-name": "Grupo 542",
    transform: "translate(-1103 -480)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1518",
    "data-name": "Ret\\xE2ngulo 1518",
    width: 69,
    height: 70,
    rx: 10,
    transform: "translate(1103 480)",
    fill: "#3fb653"
  }), /*#__PURE__*/React.createElement("g", {
    id: "smile",
    transform: "translate(1118.04 495.262)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_516",
    "data-name": "Grupo 516",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_513",
    "data-name": "Grupo 513",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_512",
    "data-name": "Grupo 512"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_175",
    "data-name": "Elipse 175",
    cx: 19.537,
    cy: 19.537,
    rx: 19.537,
    ry: 19.537,
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_519",
    "data-name": "Grupo 519",
    transform: "translate(9.674 8.717)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_517",
    "data-name": "Grupo 517"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_176",
    "data-name": "Elipse 176",
    cx: 3.11,
    cy: 3.11,
    rx: 3.11,
    ry: 3.11,
    fill: "#31d031"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_518",
    "data-name": "Grupo 518",
    transform: "translate(13.506)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_177",
    "data-name": "Elipse 177",
    cx: 3.11,
    cy: 3.11,
    rx: 3.11,
    ry: 3.11,
    fill: "#31d031"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_520",
    "data-name": "Grupo 520",
    transform: "translate(8.106 20.485)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_637",
    "data-name": "Caminho 637",
    d: "M162.155,276.156a11.445,11.445,0,0,1-11.432-11.432h3.8a7.631,7.631,0,1,0,15.262,0h3.8A11.445,11.445,0,0,1,162.155,276.156Z",
    transform: "translate(-150.723 -264.724)",
    fill: "#31d031"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappyicon);
export default __webpack_public_path__ + "static/media/happyicon.b53614d22fea6c3e84854c9f6e5dd6fb.svg";
export { ForwardRef as ReactComponent };